export function preloadImages(imagePaths: string[]): void {
  imagePaths.forEach((path) => {
    if (!path) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = path;
    link.type = "image/webp";
    document.head.appendChild(link);
  });
}
